export enum ModosVistaOportunidad {
    Listado = 'listado',
    Embudo = 'embudo',
}